import { useQuery } from "@tanstack/vue-query";
import { computed } from "vue";

import { getRelog, postLogin, postUserMe } from "@/api";
import { useSessionExpiredStore } from "@/stores/useSessionExpiredStore";

export function useUser() {
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const token = urlParams.get("token");
  const relogParams = urlParams.get("uid");

  const query = useQuery({
    queryKey: ["login"],
    queryFn: async () => {
      const store = useSessionExpiredStore();
      if (relogParams) {
        const { data } = await getRelog(relogParams);
        return data;
      }
      if (token) {
        const { response, data } = await postLogin({ token });
        if (response.status === 403) {
          store.setSessionExpired(true);
        }

        return data;
      } else {
        const { response, data } = await postUserMe();

        if (response.status === 403) {
          store.setSessionExpired(true);
        }

        return data;
      }
    },
  });

  const data = computed(() => query.data.value);
  const isError = computed(() => query.isError.value);
  const isSuccess = computed(() => query.isSuccess.value);

  return { data, isError, isSuccess, relogParams };
}
